import { EventInvitationType } from '../invitations/event-invitation.types';

export class EventMessage {
	customerIds?: number[];
	type: EventInvitationType;
	message: string;
}
